import api from "./api";

const usersApi = api.injectEndpoints({
  endpoints: (build) => ({
    getUsers: build.query<any, string>({
      query: (query = "") => `users?${query}`,
      providesTags: (result) =>
        result
          ? [
              ...result.map(({ id }) => ({ type: "Users", id })),
              { type: "Users", id: "LIST" },
            ]
          : [{ type: "Users", id: "LIST" }],
    }),
    deleteUser: build.mutation({
      query: (id) => ({
        url: `users/${id}`,
        method: `DELETE`,
      }),
      invalidatesTags: [{ type: "Users", id: "LIST" }],
    }),
    createUser: build.mutation({
      query: (user) => ({
        url: `users`,
        method: `POST`,
        body: user,
      }),
      invalidatesTags: [{ type: "Users", id: "LIST" }],
    }),
    bulkCreateUser: build.mutation({
      query: ({ emails, roles, firmId }) => ({
        url: `users/bulk`,
        method: `POST`,
        body: {
          emails,
          roles,
          firmId,
        },
      }),
      invalidatesTags: [{ type: "Users", id: "LIST" }],
    }),
    updateUser: build.mutation({
      query: (user) => ({
        url: `users/${user?.id}`,
        method: `PUT`,
        body: user,
      }),
      invalidatesTags: (result, error, { id }) => [{ type: "Users", id }],
    }),
    generateUserResetPasswordLink: build.mutation({
      query: (user) => ({
        url: `reset-password`,
        method: `POST`,
        body: user,
        responseHandler: "text",
      }),
    }),
    getUser: build.query({
      query: (id) => `users/${id}`,
    }),
  }),
});

export const {
  useGetUsersQuery,
  useDeleteUserMutation,
  useCreateUserMutation,
  useGetUserQuery,
  useUpdateUserMutation,
  useBulkCreateUserMutation,
  useGenerateUserResetPasswordLinkMutation,
} = usersApi;
